import {Analytics} from '@plaudit/analytics';

Analytics.setup();
